// extracted by mini-css-extract-plugin
module.exports = {"Z1_AComp":"Z1_A_Z1_AComp__eEO65","detailModal":"Z1_A_detailModal___cjgn"};